<template>
  <div class="card mb-25 border-0 rounded-0 bg-white top-selling-products-box">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-md-20 mb-lg-25 d-sm-flex align-items-center justify-content-between"
      >
        <h6 class="card-title fw-bold mb-0">LES PRODUITS LES PLUS VENDUS</h6>
        <router-link
          to="/Produits"
          class="card-btn mt-10 mt-sm-0 d-inline-block fw-medium text-decoration-none transition ps-10 pe-10 pt-5 pb-5"
        >
          Liste
          <i class="flaticon-logout lh-1 position-relative ms-5 top-2"></i>
        </router-link>
      </div>
      <div class="d-flex mb-12 justify-content-between align-items-center">
        <span class="fs-13 d-block fw-medium text-dark-emphasis">PRODUIT</span>
        <span class="fs-13 d-block fw-medium text-dark-emphasis">QTE VENDU</span>
      </div>
      <ul class="list ps-0 mb-0 list-unstyled">
        <li
          class="d-flex align-items-center justify-content-between"
          v-for="(product, index) in elements"
          :key="product.id"
        >
          <div class="d-flex align-items-center">
            <span class="d-block fw-bold text-black-emphasis me-15">
              {{ index + 1 }}
            </span>
            
            <div class="title ms-10 ms-md-15">
              <div
                class="fs-md-15 fs-lg-16 text-black-emphasis text-decoration-none fw-semibold"
              >
                {{ product.nomComplet }}
            </div>
              <!-- <span class="d-block fw-medium text-muted">
                {{ product.itemSold }}
                Item Sold
              </span> -->
            </div>
          </div>
          <span class="d-block fw-medium text-black-emphasis">
            {{ product.total }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import topSellingProducts from "./topSellingProducts.json";
import ApiService from "@/services/ApiService";
import { error } from "@/utils/utils";

export default defineComponent({
  name: "TopSellingProducts",
  setup() {
    const elements = ref<Array<any>>([])
      
    function getAll(page = 1, limi = 10, searchTerm = '') {
        return ApiService.get(`/ventes/top/produit?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          console.log('vent mois', data);
          elements.value = data.data;
            // mois.value = elements.value.map((item) => {
            //   return item.month;
            // });
            // totalParMois.value = elements.value.map((item) => {
            //   return parseInt(item.total);
            // });
            // isLoading.value = false;

        })
        .catch(({ response }) => {
          error(response.data)
          // isLoading.value = false;
        });
    }

    onMounted(async () => {
     await getAll();
    });

    return {
      products: topSellingProducts,
      elements,
    };
  },
});
</script>